/**
 * A service to implement functions related to Items:
 * 1 - the function to get all the Items; this function enables setting parameters to the URL. Right now,
 *  the parameters are used to: (1) obtain the Items of a Group; (2) to get the next Items of the paginated service;
 * 2 - the function to get the attributes of the identified Item: id, code, name, information related to the current
 * price and promotions, description, ingredients, nutrition, stock, menu identifier and images;
 * It also includes the items selected on each level of the menu;
 * 3 - the function to get the attributes of the identified Item: id, code, name, information related to the current
 * price and promotions, description, ingredients, nutrition, stock, menu identifier and images;
 * 4 - the function to get all the Items which the code, name or description match with the given search term;
 * 5 - the function to get the attributes of a Menu: description, levels, level's items and other settings.
 */

import {apiFetch} from '@/_helpers';


export const itemsService = {
    getAll,
    get,
    search,
    getMenu,
    getMenuItems
};

/**
 * A function to get all the Items. This function enables setting parameters to the URL. Right now,
 *  the parameters are used to:
 *  (1) obtain the items of a Group (param=group);
 *  (2) to get the next Items of the paginated service
 *
 * @param params
 * @returns {*}
 */
function getAll(params) {
    let str = Object.entries(params).map(([key, val]) => `${key}=${val}`).join('&');

    return apiFetch("items/?" + str);
}


/**
 * A function to get the attributes of the identified Item: id, code, name, information related to the current
 * price and promotions, description, ingredients, nutrition, stock, menu identifier and images
 *
 * @param pk: Item's identifier
 * @returns {*}
 */
function get(pk) {
    return apiFetch("items/" + pk + "/");
}

/**
 * A function to get the attributes of the identified Item: id, code, name, information related to the current
 * price and promotions, description, ingredients, nutrition, stock, menu identifier and images.
 * It also includes the items selected on each level of the menu.
 *
 * @param pk: Item's identifier
 * @param itemsMenuIdentifiers: level + '-' + item
 * @returns {*}
 */
function getMenuItems(pk, itemsMenuIdentifiers) {
    //Example: Request URL: http://localhost:8000/dimas/api/clapp/items/3552/?menuItems=896_3369,897_3555,898_3558
    itemsMenuIdentifiers.join(',');

    return apiFetch("items/" + pk + "/?menuItems=" + itemsMenuIdentifiers);
}


/**
 * The function to get all the Items which the code, name or description match with the given search term.
 *
 * @param searchText
 * @returns {*}
 */
function search(searchText) {
    let str = 'search=' + searchText;

    return apiFetch("items/?" + str);
}


/**
 * The function to get the attributes of a Menu: description, levels, level's items and other settings.
 *
 * @param pk Menu's identifier
 * @returns {*}
 */
function getMenu(pk) {
    return apiFetch("items/menu/" + pk + "/");
}